module.exports = __webpack_public_path__ + "static/media/Shanoot.d36353e7.png";